import React from 'react';

const ReportsPage = () => {
  return <h2>This is the Reports Page!</h2>;
};

export default ReportsPage;
